import { h, Fragment } from 'preact';
import { trackPDPToggleClick } from 'utils/tracking';
import SizeSelector from './size-selector';
import SwatchSelector from './swatch-selector';

const VariantSelector = ({
  option,
  product,
  currentVariant,
  setCurrentVariant,
  isPDP = false,
  isQuickView = false,
}) => {
  const productId = typeof product?.id === 'string' ? product?.id.split('/Product/')[1] : product?.id;
  const optionId = `product-option-${option.name}`;
  const selectedOption = currentVariant.selectedOptions.find((o) => o.name === option.name);
  const handleVariantChange = (e) => {
    const updatedOption = e.target.dataset.optionName;
    const updatedOptions = currentVariant.selectedOptions.map((o) => {
      if (o.name === updatedOption) {
        return { name: o.name, value: e.target.value };
      }
      return o;
    });
    const updatedVariant = product.variants.find(
      (v) => JSON.stringify(v.selectedOptions) === JSON.stringify(updatedOptions),
    );
    if (isPDP) {
      trackPDPToggleClick(`${option.name.toLowerCase()} ${updatedOptions[0]?.value}`);
    }

    setCurrentVariant(updatedVariant);
  };

  return (
    <>
      {option.name.toLowerCase() === 'color' ? (
        <SwatchSelector
          option={option}
          optionId={optionId}
          productId={productId}
          handleVariantChange={handleVariantChange}
          selectedOption={selectedOption}
          isQuickView={isQuickView}
        />
      ) : (
        <SizeSelector
          option={option}
          optionId={optionId}
          productId={productId}
          isQuickView={isQuickView}
          handleVariantChange={handleVariantChange}
          selectedOption={selectedOption}
        />
      )}
    </>
  );
};

export default VariantSelector;
